import axios from 'axios'

// baseURL por ambiente:
// - REACT_APP_API_BASE_URL_USEMAIS (se definida) tem prioridade — usada em homolog/sandbox/prod.
// - Sem env: dev usa a API local; qualquer outro ambiente cai na API de produção.
const baseURL =
    process.env.REACT_APP_API_BASE_URL_USEMAIS ||
    (process.env.NODE_ENV === 'development'
        ? 'http://usemaisapi.local/v1'
        : 'https://api.usemaisbrasil.com.br/v1')

console.info('Ambiente da API', baseURL)

const axiosInstance = axios.create({
    baseURL,
    validateStatus: (status) => true
})

axiosInstance.interceptors.response.use(
    (response) => {
        if(response.status === 403) {
            // localStorage.removeItem('@assistamais');
            // window.location.href = '/?dologin=true';
        }
        return response;
    },
    (error) => {
        console.error('Axios Error:', error);
        return Promise.reject(
            (error.response && error.response.data) || 'Something went wrong!'
        );
    }
)

export { axiosInstance as api }

export default axiosInstance
